import { render } from "./QuestionSettingsDialog.vue?vue&type=template&id=95d40f6a&scoped=true&lang=pug"
import script from "./QuestionSettingsDialog.vue?vue&type=script&lang=js"
export * from "./QuestionSettingsDialog.vue?vue&type=script&lang=js"

import "./QuestionSettingsDialog.vue?vue&type=style&index=0&id=95d40f6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95d40f6a"]])

export default __exports__